import {Box, Card, CardContent} from '@mui/material';
import {Typography} from '@mui/material';
import Button from '@mui/material/Button';
import React, {useState} from 'react';
import ScoreCardDialog from "../../dialogs/scoreCardDialog/scoreCardDialog";
import {recordScore} from "../../../interfaces/recordScore";
import {useAccelerator} from "../../../hooks/acceleratorDataProvider";


export default function Scoreboard({score}: { score: number }) {
    const [showScoreBoardDialog, setShowScoreBoardDialog] = useState(false);
    const {averageScore, setAverageScore} = useAccelerator();

    const setAvgScore = (response: any, scoreboard: recordScore) => {
        setAverageScore(response.avg)
    }

    return (
        <>
            <Card sx={{display: {xs: 'none', md: 'block'}}}>
                <CardContent sx={{
                        borderRadius: "10px",
                        border: "1px solid #E5E5E5",
                        padding: {xs: "12px 15px", lg:"22px 28px"},
                    }}>
                    <Typography variant="h5" sx={{
                        fontFamily: "Repro",
                        fontWeight: "700",
                        fontSize: {xs: "18px", lg:"24px"},
                        lineHeight: "110%",
                        marginBottom: {xs: "12px" ,lg: "16px"},
                    }}>Scratch Club Average</Typography>

                    <Box sx={{display: {xs: 'flex', lg: 'flex', margin: "20px 0"}}}
                    >
                        <Typography sx={{
                            fontFamily: "Repro",
                            lineHeight: "110%",
                            fontWeight: "700",
                            marginTop: "auto",
                            marginBottom: "auto",
                            marginRight: "auto",
                            padding: "0",
                            fontSize: {xs: "14px", lg: "20px"},
                        }}>
                            <Box component="img"
                                 src="https://members.performancegolf.com/wp-content/uploads/2026/01/SC-Badge.png"
                                 alt="badge"
                                 sx={{
                                     marginTop: "auto",
                                     marginBottom: "auto",
                                     marginRight: {xs: "6px", lg:"12px"}
                                 }}></Box>
                            Average Score
                        </Typography>
                        <Typography
                            sx={{
                                fontFamily: "Repro",
                                fontSize: {xs: "32px", lg: "48px"},
                                fontWeight: "900",
                                color: "#000",
                                paddingLeft: "15px",
                                marginTop: "auto",
                                marginBottom: "auto"
                            }}
                        >{averageScore}</Typography>
                    </Box>

                    <Button variant="contained" fullWidth
                            onClick={() => setShowScoreBoardDialog(true)}
                            sx={{
                                fontFamily: "Repro",
                                fontSize: "16px",
                                lineHeight: "20px",
                                backgroundColor: "#FD3300",
                                marginBottom: "0",
                                padding: "13px 0",
                                fontWeight: 700,
                                textTransform: "capitalize",
                                borderRadius: "50px",
                                "&:hover": {
                                    backgroundColor: "#DB2C00"
                                }
                            }}
                    >
                        Submit scoreboard
                    </Button>
                    {/* commented out due to the lack of functionality as per MASC20-133 */}
                    {/* <Box sx={{display: {xs: 'block', lg: 'flex'}, justifyContent: 'space-between'}}>
                    <Link to="/">
                        <img src="https://www.performancegolf.com/wp-content/uploads/2023/11/camera.png"
                             alt="camera icon"/>
                        <Typography 
                        // className={styles.scorecardLinkLabel}
                        sx={{marginBottom: "auto",
                            marginTop: "auto",
                            marginLeft: "5px",
                            fontSize: "13px",
                            '@media (min-width:1367px)': {fontSize: "15px!important"}}}
                        >Take Scorecard Photo</Typography>
                    </Link>
                    <Link to="/">
                        <img src="https://www.performancegolf.com/wp-content/uploads/2023/11/Photo-Icon-1.png"
                             alt="upload icon" />
                        <Typography
                            // className={styles.scorecardLinkLabel}
                            sx={{marginBottom: "auto",
                            marginTop: "auto",
                            marginLeft: "5px",
                            fontSize: "13px"}}
                            >Upload Scorecard Photo</Typography>
                    </Link>
                </Box> */}
                </CardContent>
            </Card>

            <ScoreCardDialog show={showScoreBoardDialog} setShow={setShowScoreBoardDialog} callback={setAvgScore}/>
        </>
    )
}
